import React, { useCallback } from 'react';
import { RadioWrapper, Label, Radio, HiddenInput, Count, RadioButton } from './RadioButton.styles';
import DotIcon from '../../../assets/icons/DotIcon';
import { COLORS } from '../../../styles/variables';

interface OptionProps {
  name: string;
  value?: string;
  label?: string | React.ReactNode;
  ariaLabel?: string;
  onChange: (option: string) => void;
  checked: boolean;
}

const Option: React.FC<OptionProps> = ({ value, onChange, name, label, ariaLabel, checked }) => {
  const inputName = `${name}-${value}`;
  const handleChange = useCallback(() => {
    if (value) onChange(value);
  }, [onChange, value]);

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key !== ' ') return;
      e.preventDefault();
      handleChange();
    },
    [handleChange],
  );

  return (
    <RadioButton>
      <Radio
        tabIndex={0}
        onClick={handleChange}
        role="radio"
        aria-label={ariaLabel}
        aria-checked={checked}
        onKeyDown={handleKeyPress}
        checked={checked}
        data-testid={`radio-button-input-${inputName}`}
      >
        {checked ? <DotIcon color={COLORS.grey80} /> : <DotIcon color={COLORS.grey15} size={8} />}
      </Radio>
      <HiddenInput
        id={inputName}
        type="radio"
        onChange={handleChange}
        checked={checked}
        name={inputName}
      />
      <Label htmlFor={inputName}>{label}</Label>
    </RadioButton>
  );
};

export default Option;
